import React from "react";

export const Footer = React.memo(() => (
  <div className="text-center">
    Copyright © {new Date().getFullYear()} PETMatchTM Alpha v0.1
  </div>
));
